import { ReactElement } from 'react';
import { BuyCryptoPage } from '@/views/BuyCrypto';
import { Page } from '@/components/Page';
import { NextPageWithLayout } from '../_app';
import { Layout } from '../../components/Layout';

export const BuyCrypto: NextPageWithLayout = () => {
  return (
    <Page title="Buy Crypto">
      <BuyCryptoPage />
    </Page>
  );
};

BuyCrypto.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};

export default BuyCrypto;
